var map = {
	"./arc.svg": 1645,
	"./atomic-design.svg": 1646,
	"./bed.svg": 1647,
	"./close.svg": 1648,
	"./copy.svg": 1649,
	"./dist.svg": 1650,
	"./docs.svg": 1651,
	"./facebook.svg": 1652,
	"./github.svg": 1653,
	"./google.svg": 1654,
	"./heart.svg": 1655,
	"./jest.svg": 1656,
	"./react-router.svg": 1657,
	"./react.svg": 1658,
	"./redux.svg": 1659,
	"./webpack.svg": 1660
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1644;


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/atoms/Icon/icons ./node_modules/raw-loader ^\.\/.*\.svg$
// module id = 1644
// module chunks = 0